/**
 * Diaper UI auth store. See `services/ops-ui/frontend/src/stores/authStore.ts`
 * for the rationale on identity URL resolution.
 */
import '../lib/capabilities';
import { createAuthStore } from '@nova-integration/ui-shared';
import { APP_ID } from '../lib/capabilities';

export const useAuthStore = createAuthStore({
  appId: APP_ID,
});
